import { useContext } from "react";
import {
  DataGridContainerContext,
  IDataGridContainerContext,
} from "./DataGrid";
import Row from "./Row";
import { IDataGridColumn, IDataGridFocusedCell } from "./type/IDataGridProps";
interface IRowsProps {
  dataColumns: IDataGridColumn[];
  stickyOffsets: any;
  focusedCell?: IDataGridFocusedCell;
  mainColor?: string;
}
const Rows = (props: IRowsProps) => {
  const { _pagedData } = useContext<IDataGridContainerContext>(
    DataGridContainerContext,
  );

  return (
    <>
      {_pagedData.length > 0 && (
        <tbody>
          {_pagedData.map((rowData: any, rowIndex: number) => {
            return (
              <Row
                rowData={rowData}
                rowIndex={rowIndex}
                key={rowIndex}
                dataColumns={props.dataColumns}
                stickyOffsets={props.stickyOffsets}
                focusedCell={props.focusedCell}
                mainColor={props.mainColor}
              />
            );
          })}
        </tbody>
      )}
      {/* {pagedData.length <= 0 && (
                <tbody>
                    <tr>
                        <td colSpan={props.columns.length}>
                            {props.emptyComponent}
                        </td>
                    </tr>
                </tbody>
            )}
            {(props.totalSummary ?? []).length > 0 &&
                <TotalSummary />
            } */}
    </>
  );
};

export default Rows;
